"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var TextSpan_1 = __importDefault(require("./components/TextSpan"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Content_1 = __importDefault(require("./styledComponents/Content"));

var ToggleWrapper_1 = __importDefault(require("./styledComponents/ToggleWrapper"));

var Button_1 = __importDefault(require("../Button"));

var Tooltip_1 = __importDefault(require("../Tooltip"));

var Text_meta_1 = require("./Text.meta");

var mobx_1 = require("mobx");

var DEFAULT_TOGGLE_BUTTONS = {
  expand: {
    text: 'Read more'
  },
  collapse: {
    text: 'Read less'
  }
};
var ACCEPT_KEYS = [shared_1.KEYS.ENTER, shared_1.KEYS.SPACE, shared_1.KEYS.SPACEBAR];

var Text =
/** @class */
function (_super) {
  __extends(Text, _super);
  /* End of accessibility */


  function Text(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Text_meta_1.TEXT_CATEGORY_KEY;
    _this.componentKey = Text_meta_1.TEXT_COMPONENT_KEY;
    _this.shouldFocusExpandedText = false;
    /* Accessbility */

    _this.initialTextProps = {
      'aria-hidden': false
    };
    _this.expandedTextProps = {};

    _this.handleKeyDown = function (e, buttonProps) {
      var key = e.key;

      if (ACCEPT_KEYS.indexOf(key) !== -1) {
        e.preventDefault(); // Hide the intial text prop to prevent screen readers from re-reading the text.

        _this.initialTextProps['aria-hidden'] = true; // Allow the expanded text to have a natural tab order - so that it can be focused.

        _this.expandedTextProps.tabIndex = 0;

        _this.handleToggle(e, buttonProps, true);
      }
    };

    _this.handleToggle = function (event, buttonProps, focusExpandedText) {
      event.stopPropagation();
      var previousToggleState = _this.toggleState || 'expanded';
      _this.isExpanded = !_this.isExpanded;
      var newToggleState = previousToggleState === 'expanded' ? 'collapsed' : 'expanded';
      var onClick = buttonProps.onClick;

      if (onClick) {
        onClick(event);
      }

      _this.toggleState = newToggleState;
      _this.shouldFocusExpandedText = focusExpandedText ? true : false;
    };

    _this.toggleState = props.toggleState || 'expanded';
    _this.isExpanded = _this.toggleState === 'expanded';
    return _this;
  }

  Object.defineProperty(Text.prototype, "allowToggle", {
    get: function get() {
      var collapse = this.props.collapse;
      return !!(collapse && collapse.maxLength && collapse.maxLength > 0 && this.textOverflowResponse && this.textOverflowResponse.counter && this.textOverflowResponse.counter.current !== this.textOverflowResponse.counter.total);
    },
    enumerable: true,
    configurable: true
  });

  Text.prototype.getTooltip = function (tooltip) {
    var placement = tooltip.placement,
        tooltipProps = __rest(tooltip, ["placement"]);

    return tooltipProps && react_1.default.createElement(Tooltip_1.default, __assign({}, tooltipProps));
  };

  Object.defineProperty(Text.prototype, "toggleButton", {
    get: function get() {
      var _this = this;

      var _a = this.props.toggleButtons,
          toggleButtons = _a === void 0 ? DEFAULT_TOGGLE_BUTTONS : _a;
      var toggleButtonsKey = this.toggleState === 'expanded' ? 'collapse' : 'expand';
      var buttonProps = toggleButtons[toggleButtonsKey];
      var additionalButtonProps = {
        onKeyDown: function onKeyDown(e) {
          return _this.handleKeyDown(e, buttonProps);
        }
      };
      return react_1.default.createElement(Button_1.default, __assign({}, buttonProps, additionalButtonProps, {
        onClick: function onClick(event) {
          return _this.handleToggle(event, buttonProps);
        },
        "aria-hidden": !this.isExpanded
      }));
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "textOverflowHelper", {
    get: function get() {
      var collapse = this.props.collapse;
      var length;
      var suffix;

      if (collapse) {
        length = collapse.maxLength;
        suffix = collapse.suffix;
      }

      var options = {
        length: length,
        suffix: suffix,
        mustStripStyle: true
      };
      return new ksys_app_template_1.helpers.TextOverflowHelper(options);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "textOverflowResponse", {
    get: function get() {
      var value = this.props.value;
      return this.textOverflowHelper.get(value || '');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "renderContent", {
    get: function get() {
      var _this = this;

      var _a = this.props,
          hasHtmlContent = _a.hasHtmlContent,
          tooltip = _a.tooltip,
          value = _a.value;
      var workingToggleState = this.allowToggle ? this.toggleState : 'expanded';
      var text = this.textOverflowResponse.content;
      var textWithoutEllipseAtEndOfText = this.removeEllipseFromEndOfString(text);
      var strippedHTMLText = this.removeHTMLTags(this.isExpanded ? textWithoutEllipseAtEndOfText : text);
      var readMoreText = value.replace(strippedHTMLText, '');
      return react_1.default.createElement(Content_1.default, {
        toggleState: workingToggleState
      }, tooltip && tooltip.placement === 'left' && this.getTooltip(tooltip), hasHtmlContent && react_1.default.createElement("span", __assign({}, this.initialTextProps, {
        dangerouslySetInnerHTML: {
          __html: this.isExpanded ? textWithoutEllipseAtEndOfText : text
        }
      })), !hasHtmlContent && react_1.default.createElement("span", __assign({}, this.initialTextProps), this.isExpanded ? textWithoutEllipseAtEndOfText : text), hasHtmlContent && react_1.default.createElement(TextSpan_1.default, __assign({
        onFocus: function onFocus() {
          return _this.handleOnFocus();
        },
        onBlur: function onBlur() {
          return _this.handleOnBlur();
        },
        shouldFocus: this.shouldFocusExpandedText,
        hidden: !this.isExpanded,
        dangerouslySetInnerHTML: {
          __html: readMoreText
        }
      }, this.expandedTextProps)), !hasHtmlContent && react_1.default.createElement(TextSpan_1.default, __assign({
        onFocus: function onFocus() {
          return _this.handleOnFocus();
        },
        onBlur: function onBlur() {
          return _this.handleOnBlur();
        },
        shouldFocus: this.shouldFocusExpandedText,
        hidden: !this.isExpanded
      }, this.expandedTextProps), readMoreText), tooltip && (!tooltip.placement || tooltip.placement === 'right') && this.getTooltip(tooltip));
    },
    enumerable: true,
    configurable: true
  });

  Text.prototype.handleOnFocus = function () {
    // Sets the initial text to not be hidden so that the screen reader can read the text after focusing the expanded text.
    // This fixes an issue where the initial text is re-read when expanding the initial text.
    this.initialTextProps['aria-hidden'] = false;
  };

  Text.prototype.handleOnBlur = function () {
    // We remove the tab index from the expanded text props to stop the TextSpan element from naturally 
    // getting focus after it was focused from the toggle button.
    var _a = this.expandedTextProps,
        tabIndex = _a.tabIndex,
        otherProps = __rest(_a, ["tabIndex"]);

    this.expandedTextProps = otherProps;
  };

  Text.prototype.removeEllipseFromEndOfString = function (text) {
    var textParts = text.split('...');
    textParts.pop();
    return textParts.join('...');
  };

  Text.prototype.removeHTMLTags = function (text) {
    return text.replace(/<[^>]*>/g, ' ').replace(/\s{2,}/g, ' ').trim();
  };

  Text.prototype.render = function () {
    var className = this.props.className;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, this.renderContent, this.allowToggle && react_1.default.createElement(ToggleWrapper_1.default, null, this.toggleButton));
  };

  Text.defaultProps = {
    value: '',
    toggleButtons: DEFAULT_TOGGLE_BUTTONS
  };

  __decorate([mobx_1.observable], Text.prototype, "toggleState", void 0);

  __decorate([mobx_1.observable], Text.prototype, "initialTextProps", void 0);

  __decorate([mobx_1.observable], Text.prototype, "expandedTextProps", void 0);

  __decorate([mobx_1.computed], Text.prototype, "allowToggle", null);

  __decorate([mobx_1.action], Text.prototype, "handleToggle", void 0);

  __decorate([mobx_1.computed], Text.prototype, "toggleButton", null);

  __decorate([mobx_1.computed], Text.prototype, "textOverflowResponse", null);

  __decorate([mobx_1.computed], Text.prototype, "renderContent", null);

  __decorate([mobx_1.action], Text.prototype, "handleOnFocus", null);

  __decorate([mobx_1.action], Text.prototype, "handleOnBlur", null);

  Text = __decorate([mobx_react_1.observer], Text);
  return Text;
}(shared_1.ComponentBase);

exports.Text = Text;
exports.default = shared_1.InjectedStyledComponent(Text, Text_meta_1.TEXT_CATEGORY_KEY, Text_meta_1.TEXT_COMPONENT_KEY);